// removed by extract-text-webpack-plugin
module.exports = {"horizontalInfoGrid":"horizontalInfoGrid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/HorizontalInfoGrid/HorizontalInfoGrid.scss
// module id = XB2u
// module chunks = 0